import script from "./TaskInner.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskInner.vue?vue&type=script&setup=true&lang=js"

import "./TaskInner.vue?vue&type=style&index=0&id=e3f4d004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f4d004"]])

export default __exports__